import { createSvgIcon } from '@mui/material';

const UnCheckIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
        <path
            d="M8.99999 0.5C4.03731 0.5 -0.00012207 4.53737 -0.00012207 9.5C-0.00012207 14.4626 4.03731 18.5 8.99999 18.5C13.9626 18.5 18 14.4626 18 9.5C18 4.53737 13.9626 0.5 8.99999 0.5ZM8.99999 17.0246C4.85085 17.0246 1.47529 13.6491 1.47529 9.5C1.47529 5.35091 4.85085 1.97541 8.99999 1.97541C13.1491 1.97541 16.5246 5.35091 16.5246 9.5C16.5246 13.6491 13.1491 17.0246 8.99999 17.0246Z"
            fill="currentColor"
        />
 
    </svg>,
    'UnCheck'
);

export default UnCheckIcon;
